<template>
  <path
    d="M4 18V6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18Z"
    fill="#FF9F04"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.1868 9.92402C10.1868 10.4343 9.77312 10.848 9.2628 10.848C8.75248 10.848 8.33878 10.4343 8.33878 9.92402C8.33878 9.4137 8.75248 9 9.2628 9C9.77312 9 10.1868 9.4137 10.1868 9.92402ZM12.6411 10.7932C12.8835 10.5507 13.2766 10.5507 13.519 10.7932L16.8182 14.0923C16.9957 14.2698 17.0488 14.5368 16.9527 14.7688C16.8567 15.0007 16.6303 15.152 16.3792 15.152H10.9415H9.78097H7.62081C7.3697 15.152 7.14334 15.0008 7.04726 14.7688C6.95119 14.5368 7.00431 14.2698 7.18183 14.0923L8.84221 12.4319C8.9586 12.3155 9.11651 12.2501 9.28115 12.2501C9.44579 12.2501 9.6037 12.3155 9.72009 12.4319L10.3612 13.073L12.6411 10.7932Z"
    fill="white"
  />
</template>
